import {
  isThereAnyContactWhoIsCompanyOrSelfEmployed,
  areAllContactsCompanies
} from '__core/shared/util/salestrekker';
/* @ngInject */

export default (
  $rootScope,
  $scope,
  $timeout,
  $state,
  $stateParams,
  $location,
  $anchorScroll,
  $q,
  $window,
  cookies,
  webpage,
  jsonFactory,
  eventService,
  helperService,
  lendersService,
  accountService,
  Contact,
  contactService,
  contactsService,
  incomeService,
  Asset,
  Ownership,
  assetsService,
  LabelType,
  Liability,
  liabilitiesService,
  Insurance,
  insurancesService,
  otherAdvisersService,
  ticketService,
  ticketsService,
  workflowService,
  labelsService,
  uiService,
  notesService,
  WorkflowType
) => {
  $scope.Model = {
    countries: [],
    addresses: [],
    organizationCountry: '',
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    availableContacts: [],
    availablePersonOnlyContacts: [],
    availableCompanyOnlyContacts: [],
    availableNonBorrowingSpouses: [],
    availableSecurityGuarantors: [],
    availableServicingGuarantors: [],
    availableSpouses: [],
    availableLabels: [],
    availableLendersPerCountry: [],
    availableIncomeTypes: incomeService.getAvailableIncomeTypes(),
    availableAssetTypes: assetsService.getAvailableAssetTypes(),
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    availableOtherAdviserTypes: [],
    availableNotes: [],
    attachmentsFiles: [],
    activeSection: 'applicant0',
    availableSections: [],
    factFindSections: [
      'income',
      'expenses',
      'assets',
      'liabilities',
      'needsAndObjectives',
      'insurance',
      'otherAdvisers'
    ],
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    openBankingData: [],
    openBankingContacts: [],
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLendersPerCountry = () => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [helperService.getOrganizationCountry().cca2]
      })
      .then((lenders) => {
        if (lenders && lenders.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableFileLabels = labels.filter(
          (l) => l.type.name === LabelType.file.name && l.isLocked
        );
        $scope.Model.availableContactLabels = labels.filter(
          (l) => l.type.name === LabelType.contact.name
        );
      });
  };

  const loadCountries = () => {
    const deferred = $q.defer();
    jsonFactory.getCountries().then((data) => {
      $scope.Model.countries = data;
      $scope.Model.organizationCountry = helperService.getOrganizationCountry().name;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadOccupations = () => {
    const deferred = $q.defer();
    jsonFactory.getOccupations().then((data) => {
      $scope.Model.occupations = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadIndustries = () => {
    const deferred = $q.defer();
    jsonFactory.getIndustries().then((data) => {
      $scope.Model.industries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact($scope.sortByIdContacts(contacts));
      if ($scope.Model.availableContacts?.length) {
        $scope.Model.availablePersonOnlyContacts = _.filter(
          $scope.Model.availableContacts,
          (c) => !c.isCompany
        );
        $scope.Model.availableCompanyOnlyContacts = _.filter(
          $scope.Model.availableContacts,
          (c) => c.isCompany
        );
        $scope.Model.availableNonBorrowingSpouses = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientNonBorrowingSpouse({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableSecurityGuarantors = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientSecurityGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableSecurityGuarantors = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientServicingGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
      }
      deferred.resolve(contacts);
    });
    return deferred.promise;
  };

  const loadSpouses = (idContacts) => {
    contactsService.getSpecific({ idContacts, isActive: true }).then((spouses) => {
      $scope.Model.availableSpouses = spouses;
    });
  };

  const loadOpenBanking = () => {
    const deferred = $q.defer();
    if (
      $rootScope.isDev() &&
      $scope.Model.currentTicket?.openBanking?.length &&
      $scope.Model.currentTicket?.sharedWith?.clientProfile?.length
    ) {
      const idContacts = [];
      const len = $scope.Model.currentTicket?.sharedWith?.clientProfile?.length || 0;
      for (let c = 0; c < len; c += 1) {
        const clientProfile = $scope.Model.currentTicket?.sharedWith?.clientProfile[c];
        const openBanking = _.find(
          $scope.Model.currentTicket?.openBanking || [],
          (o) => o?.idContact === clientProfile?.idClient && o?.isFinished && o?.hasData
        );
        if (
          clientProfile?.integrations?.isOpenBankingEnabled &&
          _.indexOf(
            $scope.Model.currentTicket?.sharedWith?.idClientsWithAccess || [],
            clientProfile?.idClient
          ) > -1 &&
          openBanking
        ) {
          idContacts.push(clientProfile?.idClient);
        }
      }
      deferred.resolve([]);
    } else {
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const loadNotes = () => {
    const deferred = $q.defer();
    notesService
      .getSpecific({ idTickets: $scope.Model.currentTicket.id, isActive: true })
      .then((notes) => {
        $scope.Model.availableNotes = notes;
        deferred.resolve(notes);
      });
    return deferred.promise;
  };

  const loadAttachments = (notes) => {
    $timeout(() => {
      let noteAttachments = notes.map((note) => {
        const attachments = [];
        for (let n = 0; n < note.attachments.length; n += 1) {
          const attach = note.attachments[n];
          attach.idNote = note.id;
          attach.noteType = note.type;
          if (_.find(attachments, { id: attach.id }) === undefined) {
            attachments.push(attach);
          }
        }
        return attachments;
      });
      noteAttachments = _.flatten(noteAttachments);
      $scope.Model.attachmentsFiles = _.union(
        $scope.Model.currentTicket.attachments,
        noteAttachments
      );
      if ($scope.Model.attachmentsFiles.length) {
        $scope.Model.attachmentsCompliance = $scope.Model.attachmentsFiles.filter(
          (a) => (a.noteType?.name !== 'video') !== undefined
        );
      }
      if ($scope.Model.attachmentsCompliance.length) {
        $scope.Model.attachmentsFiles = $scope.Model.attachmentsFiles.filter(
          (a) => a.noteType?.name !== 'video'
        );
      }
    });
  };

  const initialize = () => {
    loadLendersPerCountry();
    loadLabels();
    loadWorkflow();
    loadCountries()
      .then(() => {
        if ($scope.Model.organizationCountry === 'Australia') {
          return $q.all(loadOccupations(), loadIndustries());
        }
        return true;
      })
      .then(() => {
        loadTicket($stateParams.dd).then(() => {
          webpage.pageTitle($scope.Model.currentTicket.getName());

          $scope.getLiabilityTypes();
          $scope.getInsuranceTypes();
          $scope.getOtherAdviserTypes();

          if ($scope.Model.currentWorkflow?.isHomeLoan()) {
            $scope.Model.factFindSections.push('diversificationOpportunities');
            $scope.Model.addresses = _.map(
              $scope.Model.currentTicket?.loan?.dealLoanSecuritySplit,
              (security) => security.address
            );
          }

          loadContacts($scope.Model.currentTicket.idClients).then(() => {
            loadOpenBanking().then(() => {
              for (let c = 0; c < $scope.Model.availableContacts.length; c += 1) {
                $scope.Model.availableSections.push(`applicant${c}`);
              }

              if ($scope.Model.currentWorkflow.isHomeLoan()) {
                const idx = $scope.Model.factFindSections.indexOf('insurance');
                $scope.Model.factFindSections.splice(idx, 0, 'productRequirements');
              }

              if (!$scope.showIncome()) {
                const idx = $scope.Model.factFindSections.indexOf('income');
                $scope.Model.factFindSections.splice(idx, 1);
              }
              if (!$scope.showExpenses()) {
                const idx = $scope.Model.factFindSections.indexOf('expenses');
                $scope.Model.factFindSections.splice(idx, 1);
              }
              if (!$scope.showObjectivesInsurancesAndOtherAdvisers()) {
                const oIdx = $scope.Model.factFindSections.indexOf('needsAndObjectives');
                $scope.Model.factFindSections.splice(oIdx, 1);
                if ($scope.Model.currentWorkflow.isHomeLoan()) {
                  const pIdx = $scope.Model.factFindSections.indexOf('productRequirements');
                  $scope.Model.factFindSections.splice(pIdx, 1);
                }
                const iIdx = $scope.Model.factFindSections.indexOf('insurance');
                $scope.Model.factFindSections.splice(iIdx, 1);
                const oAIdx = $scope.Model.factFindSections.indexOf('otherAdvisers');
                $scope.Model.factFindSections.splice(oAIdx, 1);
              }

              let idSpouses = _.map(
                _.filter(
                  $scope.Model.availablePersonOnlyContacts,
                  (c) => c.person.information.idSpouse && c.person.information.idSpouse !== ''
                ),
                (s) => s.person.information.idSpouse
              );
              idSpouses = _.uniq(_.compact(idSpouses));

              if (idSpouses.length) {
                loadSpouses(idSpouses);
              }

              for (let a = 0; a < $scope.Model.currentTicket.assets.length; a += 1) {
                if (!$scope.Model.currentTicket.assets[a].ownership.length) {
                  $scope.Model.currentTicket.assets[a].ownership =
                    helperService.setOwnershipOfAssetOrLiability(
                      $scope.Model.availableContacts,
                      false
                    );
                }
              }
              for (let l = 0; l < $scope.Model.currentTicket.liabilities.length; l += 1) {
                if (!$scope.Model.currentTicket.liabilities[l].ownership.length) {
                  $scope.Model.currentTicket.liabilities[l].ownership =
                    helperService.setOwnershipOfAssetOrLiability(
                      $scope.Model.availableContacts,
                      false
                    );
                }
              }
              $scope.Model.availableSections = $scope.Model.availableSections.concat(
                $scope.Model.factFindSections
              );
              loadAccount($scope.Model.currentTicket.idOwner).then(() => {
                if (
                  $scope.Model.currentWorkflow?.type?.name === WorkflowType?.home_loan?.name
                ) {
                  loadNotes().then(() => {
                    loadAttachments($scope.Model.availableNotes);
                    $timeout(() => {
                      $scope.Model.isReady = true;
                    });
                  });
                } else {
                  $scope.Model.isReady = true;
                }
              });
            });
          });
        });
      });
  };

  initialize();

  /*
   * Fact find ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    $scope.Model.activeSection = section;
  };

  $scope.getNumberOfSection = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    return idx + 1;
  };

  $scope.previous = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      section !== 'applicant0' ? $scope.Model.availableSections[idx - 1] : section;
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.next = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      $scope.Model.availableSections[idx + 1] !== undefined
        ? $scope.Model.availableSections[idx + 1]
        : $scope.Model.availableSections[idx];
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.isNextDisabled = () => {
    const idx = $scope.Model.availableSections.indexOf($scope.Model.activeSection);
    return $scope.Model.availableSections[idx + 1] === undefined;
  };

  /*
   * Fact find ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.sortByIdContacts = (contacts) => {
    const sortedContacts = [];
    $scope.Model.currentTicket.idClients.forEach((id) => {
      const contact = contacts.find((c) => c.id === id);
      sortedContacts.push(contact);
    });
    return sortedContacts;
  };

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.areAllClientsNonBorrowingSpouse = () =>
    $scope.Model.availableNonBorrowingSpouses?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsSecurityGuarantor = () =>
    $scope.Model.availableSecurityGuarantors?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsCompanyAndSecurityGuarantor = () => {
    const clients = $scope.Model.availableCompanyOnlyContacts.concat(
      $scope.Model.availableSecurityGuarantors
    );
    return clients?.length === $scope.Model.availableContacts?.length;
  };

  $scope.areAllClientsServicingGuarantor = () =>
    $scope.Model.availableServicingGuarantors?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.allContactsAreCompanies = () =>
    _.every($scope.Model.availableContacts, (c) => c.isCompany);

  $scope.showIncome = () =>
    ($scope.Model.availablePersonOnlyContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor()) ||
    ($scope.Model.availablePersonOnlyContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.showExpenses = () =>
    !$scope.areAllClientsCompanyAndSecurityGuarantor() ||
    ($scope.Model.availableContacts.length === 1 &&
      !$scope.Model.availableContacts[0].isCompany &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }));

  $scope.showObjectivesInsurancesAndOtherAdvisers = () =>
    ($scope.Model.availablePersonOnlyContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor() &&
      !$scope.areAllClientsServicingGuarantor()) ||
    ($scope.Model.availablePersonOnlyContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }) &&
      !helperService.isClientServicingGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }) &&
      !helperService.isClientNonBorrowingSpouse({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.isThereAnyContactWhoIsCompanyOrSelfEmployed = () =>
    isThereAnyContactWhoIsCompanyOrSelfEmployed($scope.Model.availableContacts);

  $scope.areAllContactsCompanies = () =>
    areAllContactsCompanies($scope.Model.availableContacts);

  $scope.getLabel = (idLabel) => $scope.Model.availableFileLabels.find((l) => l.id === idLabel);

  $scope.getContact = (idContact) =>
    $scope.Model.availableContacts.find((c) => c.id === idContact);

  /*
   * Fact find ~ Income
   * --------------------------------------------------------------------------------
   */
  $scope.incomeAdd = (incomeType, idContact, idEmployer) => {
    incomeService.incomeAdd(
      $scope.Model.currentTicket.income,
      incomeType,
      idContact,
      idEmployer
    );
    if (idContact && idEmployer) {
      $scope.saveIncome({ income: $scope.Model.currentTicket.income });
    }
  };

  $scope.saveIncome = (data) => {
    $scope.saveTicket({ income: data?.income || [], tCD: data?.tCD || '' });
  };

  /*
   * Fact find ~ Expenses
   * --------------------------------------------------------------------------------
   */
  $scope.saveExpenses = (data) => {
    $scope.saveTicket({ expenses: data?.expenses || [], tCD: data?.tCD || '' });
  };

  /*
   * Fact find ~ Assets
   * --------------------------------------------------------------------------------
   */
  $scope.assetAdd = (assetType) => {
    assetsService.assetAdd(
      $scope.Model.currentTicket.assets,
      assetType,
      $scope.Model.availableContacts
    );
  };

  $scope.contactsHaveAssets = () =>
    _.some($scope.Model.availableContacts, (c) => c.assets.length);

  $scope.addContactAssets = (data) => {
    if (data instanceof Asset) {
      const asset = data;
      $scope.addContactAsset(asset);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let a = 0; a < contact.assets.length; a += 1) {
        const asset = contact.assets[a];
        $scope.addContactAsset(asset);
      }
    }
  };

  $scope.addContactAsset = (assetToAdd) => {
    const asset = assetToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        asset.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        asset.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idAssets = _.uniq(_.map($scope.Model.currentTicket.assets, 'id'));
    if (idAssets.indexOf(asset.idReference) === -1) {
      asset.idReference = asset.id;
      $scope.Model.currentTicket.assets.push(Asset.build(asset));
      contactsService.clearCache($scope.Model.currentTicket.assets);
      $scope.saveAssets({ assets: $scope.Model.currentTicket.assets, tCD: 'assets' });
    } else {
      uiService.toast({
        text: {
          p1: 'Asset',
          p2: asset.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveAssets = (data) => {
    $scope.saveTicket({ assets: data?.assets || [], tCD: data?.tCD || '' });
  };

  /*
   * Fact find ~ Liabilities
   * --------------------------------------------------------------------------------
   */
  $scope.getLiabilityTypes = () => {
    $scope.Model.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(
      $scope.Model.currentTicket.assets
    );
  };

  $scope.liabilityAdd = (liabilityType) => {
    liabilitiesService.liabilityAdd(
      $scope.Model.currentTicket.liabilities,
      liabilityType,
      $scope.Model.availableContacts
    );
  };

  $scope.contactsHaveLiabilities = () =>
    _.some($scope.Model.availableContacts, (c) => c.liabilities.length);

  $scope.addContactLiabilities = (data) => {
    if (data instanceof Liability) {
      const liability = data;
      $scope.addContactLiability(liability);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let l = 0; l < contact.liabilities.length; l += 1) {
        const liability = contact.liabilities[l];
        $scope.addContactLiability(liability);
      }
    }
  };

  $scope.addContactLiability = (liabilityToAdd) => {
    const liability = liabilityToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        liability.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        liability.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idLiabilities = _.uniq(_.map($scope.Model.currentTicket.liabilities, 'id'));
    if (idLiabilities.indexOf(liability.idReference) === -1) {
      liability.idReference = liability.id;
      $scope.Model.currentTicket.liabilities.push(Liability.build(liability));
      contactsService.clearCache();
      $scope.saveLiabilities({
        liabilities: $scope.Model.currentTicket.liabilities,
        tCD: 'liabilities'
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Liability',
          p2: liability.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveLiabilities = (data) => {
    $scope.saveTicket({ liabilities: data?.liabilities || [], tCD: data?.tCD || '' });
  };

  /*
   * Fact find ~ Open banking
   * --------------------------------------------------------------------------------
   */
  $scope.showOpenBankingData = (event, type) => {
    eventService.dialogOpenBanking({
      event,
      contacts: $scope.Model.openBankingContacts || [],
      openBankingData: $scope.Model.openBankingData || [],
      openBankingDataType: type,
      ticket: $scope.Model.currentTicket
    });
  };

  $scope.hasData = (type) => _.some($scope.Model.openBankingData || [], (o) => o[type]?.length);

  $scope.openBankingFinished = (data) => {
    if (data?.type && data?.selectedData?.length) {
      const updatedData = helperService.processOpenBankingData({
        data,
        ticket: $scope.Model.currentTicket,
        contacts: $scope.Model.availableContacts
      });
      if (updatedData) {
        $scope.Model.currentTicket[data?.type] = updatedData;
        $scope.saveTicket({
          [data?.type]: $scope.Model.currentTicket[data?.type],
          tCD: data?.type
        });
      }
    }
  };

  /*
   * Fact find ~ Objectives
   * --------------------------------------------------------------------------------
   */
  $scope.saveObjectives = _.debounce((objectives) => {
    $scope.saveTicket({ objectives });
  }, 1500);

  /*
   * Fact find ~ Insurance
   * --------------------------------------------------------------------------------
   */
  $scope.getInsuranceTypes = () => {
    $scope.Model.availableInsuranceTypes = insurancesService.getInsuranceTypes({
      assets: $scope.Model.currentTicket.assets
    });
  };

  $scope.canSeeInsuranceType = (insuranceType) =>
    insurancesService.canSeeInsuranceType(insuranceType);

  $scope.insuranceAdd = (insuranceType) => {
    insurancesService.insuranceAdd($scope.Model.currentTicket.insurances, insuranceType);
  };

  $scope.contactsHaveInsurance = () =>
    _.some($scope.Model.availableContacts, (c) => c.insurances.length);

  $scope.addContactInsurances = (data) => {
    if (data instanceof Insurance) {
      const insurance = data;
      $scope.addContactInsurance(insurance);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let l = 0; l < contact.insurances.length; l += 1) {
        const insurance = contact.insurances[l];
        $scope.addContactInsurance(insurance);
      }
    }
  };

  $scope.addContactInsurance = (insuranceToAdd) => {
    const insurance = insuranceToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      if (insurance.idContacts.indexOf($scope.Model.availableContacts[i].id) === -1) {
        insurance.idContacts.push($scope.Model.availableContacts[i].id);
      }
    }
    const idInsurances = _.uniq(_.map($scope.Model.currentTicket.insurances, 'id'));
    if (idInsurances.indexOf(insurance.idReference) === -1) {
      insurance.idReference = insurance.id;
      $scope.Model.currentTicket.insurances.push(Insurance.build(insurance));
      contactsService.clearCache();
      $scope.saveInsurances($scope.Model.currentTicket.insurances);
    } else {
      uiService.toast({
        text: {
          p1: 'Insurance',
          p2: insurance.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveInsurances = _.debounce((insurances) => {
    $scope.saveTicket({ insurances });
  }, 1500);

  /*
   * Fact find ~ Other advisers
   * --------------------------------------------------------------------------------
   */
  $scope.getOtherAdviserTypes = () => {
    $scope.Model.availableOtherAdviserTypes =
      otherAdvisersService.getAvailableOtherAdviserTypes({
        workflow: $scope.Model.currentWorkflow
      });
  };

  $scope.otherAdviserAdd = (otherAdviserType) => {
    otherAdvisersService.otherAdviserAdd(
      $scope.Model.currentTicket.otherAdvisers,
      otherAdviserType
    );
  };

  $scope.saveOtherAdvisers = _.debounce((otherAdvisers) => {
    $scope.saveTicket({ otherAdvisers });
  }, 1500);

  /*
   * Fact find ~ Diversification opportunities
   * --------------------------------------------------------------------------------
   */
  $scope.saveDiversificationOpportunities = _.debounce((diversificationOpportunities) => {
    if (
      diversificationOpportunities !== undefined &&
      !_.isEqual(
        $scope.Model.currentTicket.diversificationOpportunities,
        diversificationOpportunities
      )
    ) {
      $scope.Model.currentTicket.diversificationOpportunities = diversificationOpportunities;
      $scope.saveTicket({ diversificationOpportunities });
    }
  }, 1500);

  $scope.saveTicketIntegrations = _.debounce((integration, result) => {
    let needsToStore = false;
    if (integration === 'MY_CONNECT' && result?.status && result?.reference) {
      $scope.Model.currentTicket.integrations.myConnectId = result.reference;
      needsToStore = true;
    }
    if (integration === 'ALI' && result && !$scope.Model.currentTicket?.integrations?.aliId) {
      $scope.Model.currentTicket.integrations.aliId = $scope.Model.currentTicket.id;
      needsToStore = true;
    }
    if (integration === 'MOVING_HUB' && result?.customer_id && result?.reference_code) {
      $scope.Model.currentTicket.integrations.movingHub.customerId = result.customer_id;
      $scope.Model.currentTicket.integrations.movingHub.referenceCode = result.reference_code;
      needsToStore = true;
    }
    if (needsToStore) {
      $scope.saveTicket({ integrations: $scope.Model.currentTicket.integrations });
    }
  }, 1500);

  /*
   * Fact find ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  /*
   * Fact find ~ Save Contact
   * --------------------------------------------------------------------------------
   */
  $scope.saveContact = _.debounce((contact) => {
    if (contact.getName() !== 'N/A') {
      contactService.updateContact(contact).then((data) => {
        contactsService.clearCache();
        if (data.status) {
          uiService.toast({
            text: {
              p1: 'Contact',
              p2: contact.getName(),
              p3: 'has been updated'
            },
            success: true
          });
        }
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Contact',
          p2: contact.isCompany ? 'Name' : 'First name and family name',
          p3: contact.isCompany ? 'is required' : 'are required'
        },
        warn: true
      });
    }
  }, 1500);

  /*
   * Fact find ~ Save Ticket
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicket = (data) => {
    if ($scope.Model.currentWorkflow?.isHomeLoan()) {
      $scope.Model.addresses = [];
      $timeout(() => {
        $scope.Model.addresses = _.map(
          $scope.Model.currentTicket?.loan?.dealLoanSecuritySplit,
          (security) => security.address
        );
      });
    }
    const ticket = data;
    const tCD = data?.tCD || '';
    if (data?.tCD !== undefined) {
      delete ticket.tCD;
    }
    ticket.id = $scope.Model.currentTicket.id;
    ticket.name = $scope.Model.currentTicket.name;
    ticketService.updateTicket(ticket).then((result) => {
      ticketsService.clearCache();
      if (result.status) {
        uiService.toast({
          text: {
            p1: 'Deal',
            p2: $scope.Model.currentTicket.getName(),
            p3: 'has been updated'
          },
          success: true
        });
      }
      eventService.changedData({ changedData: tCD });
    });
  };
};
